import DownArrowMinimal from "@/svg/DownArrowMinimal";
import { useState } from "react";
import { ExpandableCriteriaPoints } from "./ExpandableCriteriaPoints";
import { expandFirstInclusionCriteriaPoint } from "./inclusionCriteriaPoints";

/**
 * Props for a titled inclusion-criteria accordion with dash-prefixed points.
 */
export interface InclusionCriteriaAccordionProps {
  title: string;
  points: string[];
  defaultExpanded?: boolean;
}

/**
 * Single inclusion-criteria group with a title and a list of criterion points.
 * The arrow toggles body visibility with a height/opacity animation.
 *
 * @param props - Accordion content
 * @param props.title - Category shown in the header
 * @param props.points - Criterion statements rendered as dash-prefixed rows
 * @param props.defaultExpanded - Whether the body starts open (defaults to false)
 * @returns Bordered accordion block
 */
const InclusionCriteriaAccordion = ({
  title,
  points,
  defaultExpanded = false,
}: InclusionCriteriaAccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const displayPoints = expandFirstInclusionCriteriaPoint(points);
  const canToggle = displayPoints.length > 0;

  /**
   * Expands or collapses the criterion list when the arrow is clicked.
   */
  const handleToggle = () => {
    if (!canToggle) {
      return;
    }
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="action-pending--left-content--accordion border rounded-md bg-[#FFFFFF]">
      <div className="action-pending--left-content--accordion--header flex items-center justify-between px-4">
        <div className="text text-xs font-semibold leading-5 text-[#3D3D3D] pt-3 pb-2">
          {title} : 
        </div>
        {/* <button
          type="button"
          aria-expanded={isExpanded}
          aria-label={isExpanded ? `Collapse ${title}` : `Expand ${title}`}
          disabled={!canToggle}
          onClick={handleToggle}
          className={`icon bg-transparent p-0 border-0 ${
            canToggle
              ? "hover:cursor-pointer hover:scale-105"
              : "opacity-40 cursor-not-allowed"
          } transition-transform duration-300 ease-in-out ${
            isExpanded ? "rotate-180" : ""
          }`}
        >
          <DownArrowMinimal height={10} width={10} strokeColor="#5C5C5C" />
        </button> */}
      </div>
      
        <div
          className={`grid transition-all duration-300 ease-in-out ${
            isExpanded ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
          }`}
        >
          <div className="overflow-hidden">
            <ExpandableCriteriaPoints points={displayPoints} />
          </div>
        </div>
      
    </div>
  );
};

export default InclusionCriteriaAccordion;
